define((require) => {
    "use strict";

    const LightboxAction     = require("shared/ui/experience/action/lightbox/LightboxAction");
    const ParametersHelper   = require("shared/ui/experience/action/ParametersHelper");
    const ProductActionMixin = require("shared/ui/experience/action/product/ProductActionMixin");

    /**
     * Open a product in a lightbox.
     *
     * @class ProductLightboxAction
     * @constructor
     */
    return LightboxAction.extend("ProductLightboxAction", {

        mixin: ProductActionMixin,

        _url() { // TODO: ensure editor sets the "url" always instead, no need to marshall all this
            return this.get("url") || ParametersHelper.inject(this.get("urlTemplate"), this.get("parameters"));
        }

    }, {
        TYPE: "productLightbox"
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/product/ProductLightboxAction.js